module.exports = __webpack_public_path__ + "staticcomp/img/cover.3d80840.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/15/cover.jpg
// module id = rsbW
// module chunks = 39